import { api } from "../helpers/apiHelperV3";
import { urls } from "./urls";
/**
 * Deposit funds to bank account
 */
export const fetchMarketGroupings = (sportId: number): any => {
  const API_MARKET_GROUPINGS = urls.data.API_MARKET_GROUPINGS(sportId);
  return api.get(API_MARKET_GROUPINGS);
};
